<template>
  <div class="home">

    <b-container>
      <b-card no-body border-variant="msstream" class="marginal">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h6 style="margin-bottom:0px">
            <b-icon icon="key" rotate="45" />
            {{$ml.get('quanteecKeysTitle')}}
          </h6>
        </b-card-header>
        <b-card-body>
          <b-row class="align-items-center justify-content-center mb-3">
            <h6 class="config-select-title mb-2 mb-md-0">
              {{$ml.get('selectconfig')}}: 
              &nbsp;<b-select size="sm" class="config-select-input" v-model="configUUID" :options="options"></b-select>
            </h6>
            <h6 class="d-inline-flex align-items-center config-create-zone mb-0">
              <span class="vl" />

              <b-button
                v-if="!isCreatingConfig && $auth.validateRoles(['modifyConfigurations'])"
                variant="msstreamblue"
                title="Create new configuration"
                @click="startCreateConfig"
              >
                <b-icon icon="plus-square" />
              </b-button>
              <b-button
                v-else-if="isCreatingConfig && $auth.validateRoles(['modifyConfigurations'])"
                variant="mswarning"
                title="Cancel new configuration"
                @click="cancelCreateConfig"
              >
                <b-icon icon="dash-square" />
              </b-button>

              <b-form
                v-if="isCreatingConfig && $auth.validateRoles(['modifyConfigurations'])"
                class="new-config-inline"
                @submit.prevent="onSubmit"
              >
                <b-form-input
                  size="sm"
                  type="text"
                  required
                  v-model.trim="newConfigName"
                  :placeholder="$ml.get('configname')"
                  class="new-config-input"
                ></b-form-input>
                <b-button size="sm" type="submit" variant="msstreamblue" :disabled="!newConfigName">
                  <b-icon icon="check2-square" />
                  {{$ml.get('validate')}}
                </b-button>
                <b-button size="sm" variant="mswarning" @click="cancelCreateConfig">
                  <b-icon icon="x-square" />
                  {{$ml.get('cancel')}}
                </b-button>
              </b-form>
            </h6>
          </b-row>

          <b-row class="justify-content-center align-items-center mt-3">

            <div v-if="selectedConfigurationKey" class="d-inline-flex align-items-center flex-wrap justify-content-center">
              <span class="mr-2 font-weight-bold mt-1 mb-1">{{$ml.get('quanteecKeyconfig')}}</span>
              <span class="config-key-box small mr-2 mt-1 mb-1">{{ selectedConfigurationKey }}</span>
              <span class="config-name-box small mt-1 mb-1">
                <b-icon icon="key" rotate="45" class="mr-1" />
                {{ selectedConfigurationName || selectedConfigurationLabel }}
              </span>
            </div>

            <b-badge v-else variant="light" class="config-empty-state mt-1 mb-1">
              {{$ml.get('selectconfig')}}
            </b-badge>
            
            <span class="vl mt-1 mb-1" />

            <b-button
              v-if="$auth.validateRoles(['modifyConfigurations'])"
              class="mr-2 mt-1 mb-1"
              size="sm"
              variant="msstreamred"
              v-b-modal.confirmdelete
              :disabled="!configUUID || (options.find(i => i.value === configUUID) && options.find(i => i.value === configUUID).text === 'default')"
            >
              <b-icon icon="x-square" />
              &nbsp;{{$ml.get('deleteconfig')}}
            </b-button>
            
            <b-button
              v-if="$auth.validateRoles(['readAnalytics'])"
              class="mt-1 mb-1"
              size="sm"
              variant="darkblue"
              :disabled="!selectedConfigurationKey"
              @click="analyticsSiteGlobal()"
            >
              <b-icon icon="graph-up" />
              &nbsp;{{$ml.get('analyticsLabel')}}
            </b-button>

          </b-row>
        </b-card-body>
      </b-card>

      <ConfigurationSite v-if="configUUID" class="marginalsm" :uuid="configUUID" @configuration-loaded="onConfigurationLoaded"></ConfigurationSite>
    </b-container>

    <b-modal 
      hide-footer 
      id="confirmdelete"
      @show="loadConfigName()"
      ref="confirm-delete"
      :title="$ml.get('deleteConf')"
    >
    <b-form @submit.prevent="deleteConfig()">
      <b-card no-body border-variant="msstream" class="marginal" style="margin-top:0px; margin-bottom:20px">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h6 style="margin:0px">{{$ml.get('configdelete')}}</h6>
        </b-card-header>

        <b-card-body>
          <span style="font-size:small">{{$ml.get('deleteconfirm1')}} <strong>{{configName}}</strong>{{$ml.get('deleteconfirm2')}}</span>
        </b-card-body>

      </b-card>
      <b-row>
        <div class="col-md-2"></div>
        <b-button class="col-md-3" type="submit" variant="msstreamblue" >
        <b-icon icon="check2-square" />
          {{$ml.get('yes')}}
        </b-button>
        <div class="col-md-2"></div>
        <b-button class="col-md-3" @click="closeConfirmModal()" variant="msstreamred">
          <b-icon icon="slash-circle" />
           {{$ml.get('no')}}
        </b-button>
      </b-row>
    </b-form>
    </b-modal>

<CopiedModal ref="copied"></CopiedModal>
  </div>
</template>

<script>
import CopiedModal from '@/components/modals/CopiedModal.vue';
import ConfigurationSite from '@/components/ConfigurationSite.vue';
import UserService from '@/services/user.service.js';
import ConfigurationService from '@/services/configuration.service.js';
import ClientService from '@/services/client.service'
var clientService = new ClientService()
let userService = new UserService();
let configService = new ConfigurationService();

export default {
  name: 'ConfigPage',
  components: {
    ConfigurationSite,
    CopiedModal
  },
  watch: {
    configUUID(newValue) {
      this.selectedConfigurationName = '';
      this.selectedConfigurationKey = '';
      if (newValue) {
        const selected = this.options.find((option) => option.value === newValue);
        this.selectedConfigurationName = selected ? selected.text : '';
      }
    }
  },
  data() {
    return {
      clientView: this.$auth.isAdmin()
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      streamKey: '',
      configUUID: "",
      configName:"",
      selectedConfigurationName: '',
      selectedConfigurationKey: '',
      newConfigName:"",
      isCreatingConfig: false,
      options: [
        
      ]
    }
  },
  computed: {
    selectedConfigurationLabel() {
      const selected = this.options.find((option) => option.value === this.configUUID);
      return selected ? selected.text : '';
    },
  },
  mounted() {
    //this.getUsers();
    this.getConfigs();
    this.getStreamKeys();
  },
  methods: {
    onConfigurationLoaded(configuration) {
      this.selectedConfigurationName = configuration && configuration.name ? configuration.name : '';
      this.selectedConfigurationKey = configuration && configuration.key ? configuration.key : '';
    },
    getStreamKeys() {
      clientService.getClientStreamKeys(this.clientView, this.$auth.token()).then(keys => {
        this.streamKey = keys.keys[0];
      }).catch(err => {
        console.log(err);
      })
    },
    getConfigs() {
      configService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
        configurations._embedded.sort((a,b) => a.name.localeCompare(b.name));
        let startWith = 0;
        if (this.$route.query && this.$route.query.start) {
          let idxStart = configurations._embedded.findIndex(x => x.name === this.$route.query.start);
          if (idxStart > -1) {
            startWith = idxStart;
          }
        }
        this.options = configurations._embedded.map(x => { return { value: x.uuid, text: x.name } });

        if (this.options.length>0) {
          this.configUUID = this.options[startWith].value;
        }

        if (this.configUUID) {
          this.selectedConfigurationName = this.options[startWith].text;
          this.selectedConfigurationKey = '';
        }


      }).catch(err => {
        console.log(err);
      })
    },
    startCreateConfig() {
      this.isCreatingConfig = true;
      this.newConfigName = '';
    },
    cancelCreateConfig() {
      this.onReset();
      this.isCreatingConfig = false;
    },
    onSubmit: function () {
      if (!this.newConfigName) {
        return;
      }
      let data = {
        name:this.newConfigName,
        client: this.clientView
      }
      configService.postConfiguration(data, this.$auth.token()).then((response)=>{

        this.options.push({value:response.uuid, text:response.name})
        this.options.sort((a,b) => a.text.localeCompare(b.text));
        this.configUUID = response.uuid;
        this.selectedConfigurationName = response.name;
        this.selectedConfigurationKey = '';
        this.isCreatingConfig = false;
        this.onReset();

      }).catch(err => {
        console.log(err);
      })
    },
    onReset: function () {
      this.newConfigName = "";
    },
    loadConfigName: function() {

      var idx = this.options.findIndex(i => i.value === this.configUUID);
      this.configName = this.options[idx].text;
      console.log(this.configName)
    },
    closeConfirmModal: function() {
      this.$refs['confirm-delete'].hide()
    },
    deleteConfig: function() {
      configService.deleteConfiguration(this.configUUID, this.$auth.token()).then((response)=>{
        
        var indexdelete = this.options.findIndex(i => i.value === this.configUUID);
        this.options.splice(indexdelete,1)
        if(this.options.length>0)
        {
          this.configUUID = this.options[0].value;
        } else {
          this.configUUID = ""
          this.selectedConfigurationName = '';
          this.selectedConfigurationKey = '';
        }
        this.$refs['confirm-delete'].hide()
        console.log(response)
      }).catch(err => {
        console.log(err);
      })
    },
  }
}
</script>

<style scoped lang="scss">
.config-empty-state {
  border: 1px dashed rgba(47, 144, 176, 0.6);
  color: #2a5d77;
  background: rgba(47, 144, 176, 0.06);
}

.vl {
  border-left: 1px solid #2a5d77;
  height: 20px;
  margin-left: 1rem;
  margin-right: 1rem;
}

.new-config-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 0.75rem;
  flex-wrap: wrap;
}

.new-config-input {
  width: 220px;
}

.config-select-input {
  width: 300px;
  max-width: 100%;
}

.config-select-title {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  justify-content: center;
}

.config-create-zone {
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 768px) {
  .config-select-title {
    width: 100%;
    justify-content: flex-start;
  }

  .config-select-input {
    width: 100%;
  }

  .config-create-zone {
    width: 100%;
    justify-content: flex-start;
  }

  .vl {
    display: none;
  }

  .new-config-inline {
    width: 100%;
    margin-top: 0.5rem;
    margin-left: 0;
    flex-wrap: wrap;
    gap: 0.4rem;
  }

  .new-config-input {
    width: 100%;
  }
}

</style>
